import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Typography } from '@mui/material';
import DataStore from './../../../stores/DataStore'
/**
  * @class
  * Zur Anzeige einer Gruppe an Radiobuttons 
  * @name RadioButtonGroupAttribute
  * @implements {Attribute}
  */
class RadioButtonGroupAttribute extends Component {
  constructor(params) {
    super(params);
  }

  onChange(evt) {
    const { attribute: { onChange } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = "" } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return (
      <div>{this.getValueString()}</div>
    )
  }

  getRadioButtons() {
    const {
      attribute: { attributeOption = {} } = {},
    } = this.props;
    const { labels } = attributeOption;
    const radioButtons = [];
    labels.forEach(l => {
      radioButtons.push(
        <FormControlLabel value={l} key={this.id + l} control={<Radio />} label={l} />,
      );
    });
    return radioButtons;
  }

  render() {
    const {
      attribute: {
        id = '',
        name = '',
        attributeOption: {
          FormCtrl = FormControl,
          FormL = FormLabel,
          RadioGrp = RadioGroup,
          FormControlLabelProps = {},
          FormLabelProps = {},
          RadioGroupProps = {}
        },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      <FormCtrl {...FormControlLabelProps} component="fieldset">
        <FormL {...FormLabelProps} component="legend">{name}</FormL>
        <RadioGrp
          aria-label={name}
          disabled={DataStore.attributeValues[this.id].readOnly}
          name={name}
          key={id}
          value={DataStore.attributeValues[this.id].value}
          onChange={evt => this.onChange(evt)}
          {...RadioGroupProps}
        >
          {this.getRadioButtons()}
        </RadioGrp>
      </FormCtrl>
    );
  }
}

export default RadioButtonGroupAttribute;

// TODO: Wie siehts hier mit den Attributabhängigkeiten aus? Bzw generell mit den RUles bzw Conditions?
